import { render } from "./GiftQuestion.vue?vue&type=template&id=3a885902"
import script from "./GiftQuestion.vue?vue&type=script&lang=js"
export * from "./GiftQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__